<template>
  <v-form ref="form" class="mad-template-form" @submit.prevent="onSubmit">
    <v-text-field v-model="form._id" style="display: none"/>
    <v-text-field
        v-model="form.title"
        background-color="#D6D9E6"
        flat
        single-line
        outline
        height="37px"
        :rules="formRules.required"
        :placeholder="$t('MADTemplate.title') | capitalize"/>
    <v-textarea
        v-model="form.content"
        ref="blockReason"
        background-color="#D6D9E6"
        auto-grow
        flat
        outline
        rows="5"
        :rules="formRules.required"
        :placeholder="$t('MADTemplate.content') | capitalize"
    ></v-textarea>
    <div class="dialog-action">
      <v-btn small outline color="#0052CC" style="margin-left: auto" @click="onCancel">{{$t('cancel') | capitalize}}</v-btn>
      <v-btn small color="#0052CC" class="white--text" type="submit">{{$t('save') | capitalize}}</v-btn>
    </div>
  </v-form>

</template>

<script>
import FormMixin from "@/mixins/FormMixin";

export default {
  name: "MADTemplate",
  mixins: [FormMixin],
  props: {
    template: {
      type: Object
    }
  },
  computed: {
    form() {
      return {
        _id: this.template._id || "",
        title: this.template.title || "",
        content: this.template.content || "",
      }
    }
  },
  methods: {
    onCancel() {
      this.$refs.form.reset()
      this.$emit('on-cancel')
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        const data = {...this.form};
        this.$emit('on-submit', data)
        this.$refs.form.reset()
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "components/style/mad-template-form";
</style>
